export const isValidPhoneNumber = (number) => {
  return (
    (number?.trim().startsWith("0") && number?.trim()?.length === 11) ||
    (number?.trim()?.startsWith("+234") && number?.trim()?.length === 14)
  );
};

export const isValidEmail = (email) => {
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
};

export const isValidString = (string) => string?.trim()?.length > 0;
